module.exports = __webpack_public_path__ + "img/oowakudani_kurotamago_kan.e2338d23.jpg";